var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagesBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6373 20.4657C9.08268 20.3397 8.53877 20.1552 8.01529 19.9121C7.56868 19.7325 7.2038 19.587 6.85741 19.587C5.89024 19.5919 4.68565 20.533 4.06098 19.9062C3.43534 19.2785 4.37332 18.0708 4.37332 17.0945C4.37332 16.746 4.23418 16.3857 4.05514 15.9385C2.65985 12.912 3.19792 9.21183 5.68785 6.71445C8.8657 3.52487 14.0295 3.52487 17.2083 6.71445",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3227 19.9888C16.4175 20.8724 14.0891 20.5317 12.5167 18.9539C10.5094 16.9398 10.5055 13.6712 12.5167 11.6532C14.524 9.63904 17.7856 9.63904 19.7929 11.6532C21.3643 13.2309 21.7048 15.5681 20.8233 17.4797C20.7104 17.7619 20.6229 17.9894 20.6229 18.209C20.6229 18.8261 21.2144 19.5885 20.8194 19.9849C20.4253 20.3813 19.6644 19.7867 19.0544 19.7828C18.8345 19.7838 18.6039 19.8746 18.3227 19.9888Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesBubble);
export default __webpack_public_path__ + "static/media/messages-bubble.ffb74a1d0dae03057b997a570d2f43eb.svg";
export { ForwardRef as ReactComponent };